import { render } from "./IconUndo.vue?vue&type=template&id=250bb893"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconUndo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "250bb893"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('250bb893', __exports__)) {
    api.reload('250bb893', __exports__)
  }
  
  module.hot.accept("./IconUndo.vue?vue&type=template&id=250bb893", () => {
    api.rerender('250bb893', render)
  })

}


export default __exports__